// window._bl = { partner: 'monicaandandy.com' };

// for (button of document.getElementsByClassName("add-to-babylist")) {
//   button.addEventListener("click", function(event) {
// 	var imageContainer = $('.product-image-main');
//     var imageUrl = $('.slick-current .product-image-main .photo-zoom-link').attr('data-zoom-size');
//     var productPrice = $('.product-single__meta .product__price').text();
//     var productTitle = $('.product-single__title').text();
//     var variantTitle = $('.variant-input-wrap input[type="radio"]:checked').attr('value');
    
//     bl.addToRegistry({     
//       images: imageUrl,
//       price: button.dataset.price,
//       title: productTitle + " - " + variantTitle,
//       url: button.dataset.url,
//     });
//     event.preventDefault();
//   });
// }

window._bl = { partner: 'monicaandandy.com' };

for (button of document.getElementsByClassName("add-to-babylist")) {
  button.addEventListener("click", function(event) {
    var imageUrl      = $(".slick-current img[role='presentation']").attr('src');
    var productPrice  = $("[itemprop='price']").text().trim();
    var productTitle  = $("[itemprop='name']").text().trim();
    var variantTitle  = $('#product-variants input[type="radio"]:checked').attr('value').trim();
    
    bl.addToRegistry({     
      images: imageUrl,
      price: productPrice,
      title: productTitle + " - " + variantTitle,
      url: window.location,
    });
    event.preventDefault();
  });
}
